/**
 * Public address-bar / share identifier.
 * Prefer shortCode; fall back to Mongo id so unrefilled records and old links still work.
 */
export function publicAppointmentRef(appointment?: {
  shortCode?: string;
  id?: string;
  _id?: string;
} | null): string {
  return appointment?.shortCode || appointment?.id || appointment?._id || '';
}

export function publicStylistRef(stylist?: {
  shortCode?: string;
  id?: string;
  _id?: string;
} | null): string {
  return stylist?.shortCode || stylist?.id || stylist?._id || '';
}
